import axios from "axios";
import Item from './Item';
import Loading from "./Loading";
import None from "./None";
import AddNew from "./AddNew";



class ItemList extends React.Component {
    constructor(props) {
        super(props);
        console.warn('CONSTRUCTOR');
        this.state = {
            propertyType: '',
            item: [],
            loading: true,
            keyword: this.props.keyword,
            county: this.props.county,
            minprice: this.props.minprice,
            maxprice: this.props.maxprice,
            sort: this.props.sort,
            lazyImages: null
        }
    }



    componentDidMount() {
        console.warn('componentDidMount');

        let selectedTab = this.props.selectedTabId;
        let selectedTabSlug1 = this.props.selectedTabSlug1;
        let auctionType = this.props.auctionType;

        const lazyImageObserver = new IntersectionObserver(entries => {
            entries.forEach(entry => {
                if (entry.isIntersecting) {
                    const lazyImage = entry.target;
                    lazyImage.style.backgroundImage = lazyImage.dataset.url;
                    lazyImage.classList.remove('lazy');
                    lazyImageObserver.unobserve(lazyImage);
                }
            })
        })

        if (selectedTab === 1 || selectedTab === 2 || selectedTab === 4 || selectedTab === 5 || selectedTab === "kv24" || selectedTab === "city24" || selectedTab === "soov") {
            axios.get(`/index.php?f=${this.props.fileName}&t=${selectedTab}${this.props.keyword ? this.props.keyword : ''}${this.props.minprice ? this.props.minprice : ''}${this.props.maxprice ? this.props.maxprice : ''}${this.props.county ? this.props.county : ''}${this.props.sort ? this.props.sort : ''}`)
            .then(function(res) {
                console.log('selectedTab ? 1 2 4 5 kv24 city24 soov', res);
                const items = res.data;
                const county = res.data.county;
                this.setState({
                    item: items,
                    loading: false
                })
                this.props.addToCounty(county);

                this.setState({ lazyImages: document.querySelectorAll('.lazy-loaded-image.lazy') })
                this.state.lazyImages.forEach(lazyImage => { lazyImageObserver.observe(lazyImage) });

            }.bind(this))
            .catch(function (error) {});
        } else if (selectedTab === 501 || selectedTab === 502 || selectedTab === 503) {
            axios.get(`/index.php?f=${this.props.fileName}${selectedTabSlug1 ? `&a=${selectedTabSlug1}` : ''}&t=${auctionType}${this.props.keyword ? this.props.keyword : ''}${this.props.minprice ? this.props.minprice : ''}${this.props.maxprice ? this.props.maxprice : ''}${this.props.county ? this.props.county : ''}${this.props.sort ? this.props.sort : ''}`)
            .then(function(res) {
                console.log('selectedTab ? 501 502 503', res);
                const items = res.data;
                const county = res.data.county;
                this.setState({
                    item: items,
                    loading: false
                });
                this.props.addToCounty(county);

                this.setState({ lazyImages: document.querySelectorAll('.lazy-loaded-image.lazy') })
                this.state.lazyImages.forEach(lazyImage => { lazyImageObserver.observe(lazyImage) });

            }.bind(this))
            .catch(function (error) {
                console.log(error);
            });
        } else if (selectedTab === 1001 || selectedTab === 1002 || selectedTab === 1003) {
            axios.get(`/index.php?f=${this.props.fileName}`)
            .then(function(res) {
                const items = res.data;
                const county = res.data.county;
                this.setState({
                    item: items,
                    loading: false
                });
                this.props.addToCounty(county);

                this.setState({ lazyImages: document.querySelectorAll('.lazy-loaded-image.lazy') })
                this.state.lazyImages.forEach(lazyImage => { lazyImageObserver.observe(lazyImage) });

            }.bind(this))
            .catch(function (error) {
                console.log(error);
            });
        } else if (selectedTab) {
            axios.get(`/index.php?f=${this.props.fileName}&t=${selectedTab}${this.props.keyword ? this.props.keyword : ''}${this.props.minprice ? this.props.minprice : ''}${this.props.maxprice ? this.props.maxprice : ''}${this.props.county ? this.props.county : ''}${this.props.sort ? this.props.sort : ''}`)
            .then(function(res) {
                const items = res.data;
                const county = res.data.county;
                this.setState({
                    item: items,
                    loading: false,
                });
                this.props.addToCounty(county);

                this.setState({ lazyImages: document.querySelectorAll('.lazy-loaded-image.lazy') })
                this.state.lazyImages.forEach(lazyImage => { lazyImageObserver.observe(lazyImage) });

            }.bind(this))
            .catch(function (error) {});
        }
    }



    render(item = this.state.item.objects) {
        console.warn('RENDER');

        if (!this.state.loading) {
            if (item.length > 0) {
                return (
                    <React.Fragment>
                        {this.props.page === "my_post" || this.props.page === "my_auction" ?
                            <AddNew item={item.length} page={this.props.page}/> :
                            ''
                        }
                        {item.map(item => {
                            return (
                                <Item
                                    key={item.id}
                                    id={item.id}
                                    owner={item.owner}
                                    type={item.type}
                                    subtype={item.subtype}
                                    status={item.status}
                                    image={item.image}
                                    name={item.name}
                                    county={item.county}
                                    price={item.price}
                                    date={item.date}
                                    startDate={item.start_date}
                                    endDate={item.end_date}
                                    link={item.link}
                                    img={item.img}
                                    bid={item.bid}
                                    external_link={item.external_link}
                                    page={this.props.page}
                                    auctionType={this.props.auctionType}
                                    selectedTabSlug1={this.props.selectedTabSlug1}
                                />
                            )
                        })}
                    </React.Fragment>
                )
            } else {
                return (
                    <React.Fragment>
                        {this.props.page === "my_post" || this.props.page === "my_auction" ?
                            <AddNew page={this.props.page}/> :
                            <None page={this.props.page}/>
                        }
                    </React.Fragment>);
            }
        } else { return <Loading/>; }
    }
}

export default ItemList;